import React from "react";
import PropTypes from "prop-types";
import "./index.css";
import { Spin } from "antd";
import GeneralInfo, { GeneralInfoPropTypes } from "./GeneralInfo";
import UsersTable, { UserTablePropsType } from "./UsersTable";
import { MultiSelect } from "../multiSelect";
import { isNullOrUndefined } from "../../common/utils";

function InfoTab(
  {
    isLoading,
    isErrorState,
    generalInfo,
    listOfTables,
    columnSelect,
    containerId,
    userGroupUniqueName,
    isGroupMembersTable = false
  }) {
  containerId = isNullOrUndefined(containerId) ? "info-tab" : containerId;

  function renderBasicInfo(generalInfo) {
    return (
      <GeneralInfo
        leftSideRenderElements={generalInfo.leftSideRenderElements}
        rightSideRenderElements={generalInfo.rightSideRenderElements}
      />
    );
  }

  function renderUsersTable(listOfTables) {
    let tablesToBeRendered = [];
    listOfTables.forEach((tableProp) => {
      let table = null;
      if (!isLoading) {
        table = (
          <UsersTable
            key={`${tableProp.tableProps.tableId} ${tableProp.tableProps.tableName}`}
            copyEmails={tableProp.copyEmails}
            label={tableProp.label}
            tableProps={tableProp.tableProps}
            noUserMessage={tableProp.noUserMessage}
            individualInclusionMembers={tableProp.individualInclusionMembers}
            groupUniqueName={userGroupUniqueName}
            isGroupMembersTable={isGroupMembersTable}
            overridenNoOfUsers={tableProp.overridenNoOfUsers}
          />
        );
      }
      tablesToBeRendered.push(table);
    });
    return tablesToBeRendered;
  }

  function renderColumnSelect(columnSelect) {
    return (
      <>
        {columnSelect.shouldRender === true ? (
          <div className="select-column-info-tab">
            <MultiSelect
              placeHolder={"Select Columns"}
              options={columnSelect.totalColumns}
              selected={columnSelect.selectedColumns}
              onSelected={(value) => columnSelect.onSelected(value)}
              containerId={containerId}
              pinned={null}
            />
          </div>
        ) : null}
      </>
    );
  }

  return (
    <Spin
      id={containerId}
      spinning={isLoading}
    >
      <div className="info-view">
        {renderBasicInfo(generalInfo)}
        {!isErrorState ? (
          <>
            {renderUsersTable(listOfTables)}
            {renderColumnSelect(columnSelect)}
          </>
        ) : (
          <span className="error-text">Details Not Loaded</span>
        )}
      </div>
    </Spin>
  );
}

export default InfoTab;

InfoTab.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isErrorState: PropTypes.bool.isRequired,
  generalInfo: PropTypes.exact({ ...GeneralInfoPropTypes }).isRequired,
  listOfTables: PropTypes.arrayOf(PropTypes.exact({ ...UserTablePropsType })).isRequired,
  columnSelect: PropTypes.exact({
    shouldRender: PropTypes.bool,
    totalColumns: PropTypes.array,
    selectedColumns: PropTypes.array,
    onSelected: PropTypes.func,
  }).isRequired,
  containerId: PropTypes.string,
};
